export const TILE_SIZE_PX = 96;

/** Above this size a thumbnail is not worth the bytes — the tile shows a glyph instead. */
export const IMAGE_THUMBNAIL_MAX_BYTES = 15 * 1024 * 1024;

/** Above this the file downloads instead of opening in a viewer. */
export const PREVIEW_MAX_BYTES = 100 * 1024 * 1024;
